import React from "react";
import { StatusChip } from "../../../../../component/listing";
import { tokens } from "../../../../../theme";

/**
 * One day of somebody's attendance, as columns.
 *
 * "My attendance" and an admin looking at one employee show exactly the same
 * eight things about a day; they differ only in whose days they are. Declared
 * once so the two cannot drift into describing the same record differently.
 *
 * The helpers are passed in rather than imported because each screen already
 * holds its own copies from its own module.
 */
export const attendanceDayColumns = ({ statusOf, statusTone, locationOf, clockInOf, clockOutOf, getDuration }) => [
  { key: "date", label: "Date", cellSx: { fontWeight: 600 }, render: (row) => row?.dayString || "—" },
  {
    key: "status",
    label: "Status",
    render: (row) => {
      const status = statusOf(row);
      return <StatusChip label={status} tone={statusTone[status]} />;
    },
  },
  { key: "location", label: "Location", cellSx: { color: tokens.textMuted }, render: (row) => locationOf(row) },
  { key: "in", label: "Clock In", render: (row) => clockInOf(row) },
  { key: "out", label: "Clock Out", render: (row) => clockOutOf(row) },
  { key: "break", label: "Break", cellSx: { color: tokens.textMuted }, render: (row) => getDuration(row?.breakHours || 0) },
  { key: "total", label: "Total", align: "right", cellSx: { color: tokens.textMuted }, render: (row) => getDuration(row?.totalHours || 0) },
  { key: "effective", label: "Effective", render: (row) => getDuration(row?.effectiveHours || 0) },
];
